import { useLayoutEffect, useState } from 'react'
import { Card, Wrap } from 'shared/components/Base/Card'
import { Button } from 'shared/components/Button/Button'
import { PendingIconLarge } from 'shared/components/Icons/Icon'
import { InlineSpinner } from 'shared/components/Spinner'
import { Text } from 'shared/components/Text/Text'
import { Handler } from 'shared/helpers/typeHelper'
import { midGray } from 'shared/theme/colors'

import { useBackgroundCheck } from '../../../hooks/query/useBackgroundCheck'
import { createBackgroundCheck } from '../../../models/backgroundCheck'
import { User } from '../../../models/user'

interface HirerightApplicationProps {
  nextStep: Handler
  user: User
}

export function HirerightApplication({ nextStep, user }: HirerightApplicationProps) {
  const [checkCreated, setCheckCreated] = useState(false)
  const { backgroundCheck, isLoading } = useBackgroundCheck({ userId: user.id, enabled: checkCreated })

  useLayoutEffect(() => {
    if (!checkCreated) {
      createBackgroundCheck(user.id).finally(() => setCheckCreated(true))
    }
  }, [user.id, checkCreated])

  useLayoutEffect(() => {
    if (backgroundCheck?.invitation_complete) {
      nextStep()
    }
  }, [backgroundCheck?.invitation_complete, nextStep])

  if (isLoading || !checkCreated) return <InlineSpinner />

  function renderContent() {
    if (!backgroundCheck || !backgroundCheck.invitation_url)
      return (
        <>
          <Text variant="header2" mt={1} mb={2} align="left">
            HireRight order not created.
          </Text>
          <Text variant="paragraph2" color={midGray} align="left">
            Please contact us.
          </Text>
        </>
      )

    return (
      <>
        <Text variant="header2" mt={1} mb={3} align="left">
          Continue your application in HireRight
        </Text>
        <Text variant="paragraph2" color={midGray} mb={5} align="left">
          Once done, return to CloudTrucks app to complete your remaining tasks.
        </Text>

        <Button
          variant="primary"
          onClick={() => window.open(backgroundCheck?.invitation_url, '_blank')}
          margin="0 auto"
        >
          Go to hireright
        </Button>
      </>
    )
  }

  return (
    <Wrap maxWidth="460px">
      <Card noShadow>
        <img src={PendingIconLarge} alt="" width="52px" height="52px" />
        {renderContent()}
      </Card>
    </Wrap>
  )
}
